import get from 'lodash/get';

const styles = ({ color, fontSize, margin, padding }) => ({
  headerContainer: {
    padding: `0 ${get(padding, 'p36')}`,
  },
  pageTitle: {
    margin: `${get(margin, 'm5')} 0`,
    wordWrap: 'break-word',
  },
  statusBar: {
    margin: `${get(margin, 'm5')} 0 ${get(margin, 'm21')} 0`,
    '& span': {
      position: 'relative',
      display: 'inline-block',
      marginBottom: '5px',
      paddingLeft: '15px',
      verticalAlign: 'middle',
      fontSize: get(fontSize, 'smallText'),
      letterSpacing: 0,
    },
  },
  status: {
    fontSize: `${get(fontSize, 'bodyText')} !important`,
    '&:before': {
      display: 'inline-block',
      position: 'absolute',
      content: '""',
      left: 0,
      top: '50%',
      marginTop: '-6px',
      height: '10px',
      width: '10px',
      borderRadius: '10px',
    },
  },
  available: {
    color: get(color, 'success'),
    '&:before': {
      backgroundColor: get(color, 'success'),
    },
  },
  pendingEnrollment: {
    color: get(color, 'disabledGraphic'),
    '&:before': {
      backgroundColor: get(color, 'disabledGraphic'),
    },
  },
});

export default styles;



// WEBPACK FOOTER //
// ./src/components/Details/Header/styles.js